import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  subline?: string;
  id?: string;
  size?: 'default' | 'large';
};
export function CTAButton({
  label,
  subline,
  id,
  size = 'default'
}: CTAButtonProps) {
  return <div className="w-full" data-id="element-29" data-mp="2fz21inlqkyw1">
      <a id={id} href={CHECKOUT_URL} className={['group flex w-full items-center justify-center gap-3 rounded-2xl bg-gogreen-500 px-5 text-center font-extrabold uppercase tracking-tight text-white', 'shadow-[0_10px_0_0_#0E6C33] transition-[transform,background-color] duration-150 ease-out', 'hover:bg-gogreen-600 active:translate-y-[6px] active:shadow-[0_4px_0_0_#0E6C33]', 'focus:outline-none focus-visible:ring-4 focus-visible:ring-gogreen-500/40', size === 'large' ? 'py-5 text-base leading-tight sm:text-xl' : 'py-4 text-[15px] leading-tight sm:text-lg'].join(' ')} data-id="element-30" data-mp="2fys78ntns5kj">
        <CheckCircleIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-31" data-mp="199elkjbamkiu" />
        <span data-id="element-32" data-mp="1dai2l952umln">{label}</span>
      </a>
      {subline ? <p className="mt-3 text-center text-[13px] font-medium leading-relaxed text-navy-800/70 sm:text-sm" data-id="element-33" data-mp="1db9qdxsfng1d">
          {subline}
        </p> : null}
    </div>;
}